import { NoRecommendationsReasons } from '../../no-recommendations-reasons.enums';
import { ConditionContext } from './condition-context.interface';

export const kNameOfCondition = 'Condition';

export type MatchResult = [boolean, NoRecommendationsReasons?];

// -----------------------------------------------------------------------------
// Global conditions are matched on a per-game basis and not on a per-app basis.
// These can also include broader conditions - like cross-games.
// Global conditions are matched prior to any app conditions.
export interface ICondition {
  // Used for logging
  readonly id: string;

  // For app's with specific conditions, this is how we can identify the right
  // condition
  shouldSkip?(context: ConditionContext);

  // The matching method
  match(context: ConditionContext): Promise<MatchResult>;
}
